export default {"src":"/_next/static/image/public/images/ic_upload_white_small.8811cc750d9bf46d1c1726b05ceadd57.svg","height":20,"width":20};